import React, { useEffect } from 'react'
import { Box, Typography, Grid, CircularProgress, Stack } from '@mui/material'
import useFetchLead from '../../../api/lead/useFetchLead'
import { formatPhoneNumber } from '../../../utils/FormatPhoneNumber/FormatPhoneNumber'

const inputStyle = {
	minHeight: '20pt',
	border: '1px solid #ccc',
	marginBottom: '24px',
	padding: '8px',
}

export default function LeadDetail({ leadId, dismiss }) {
	const { loading, leadDetails: lead, error } = useFetchLead(leadId)

	useEffect(() => {
		if (error) {
			dismiss()
		}
	}, [error])

	return (
		<Grid
			container
			direction="column"
			alignItems="center"
			spacing={0}
			sx={{
				width: '100%',
				padding: '32px',
			}}
		>
			<Grid item sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
				<Box
					sx={{
						width: '100%',
						display: 'flex', // Enables flex layout
						justifyContent: 'flex-end', // Aligns children to the right
					}}
				></Box>
			</Grid>

			<Grid item sx={{ width: '100%', display: 'flex', justifyContent: 'left' }}>
				<Typography
					variant="h2"
					textAlign="left"
					sx={{ fontSize: '32pt', lineHeight: '42pt', marginBottom: '24px' }}
				>
					Lead Details
				</Typography>
			</Grid>

			{loading && (
				<Stack height="200px" marginTop="20px">
					<CircularProgress />
				</Stack>
			)}

			{!loading && (
				<Stack width="100%">
					<Grid container spacing={2}>
						<Grid item xs={6}>
							<Typography
								variant="body2"
								textAlign="left"
								sx={{ fontSize: '13pt', marginBottom: '12px' }}
							>
								Name
							</Typography>
							<Box display="flex" allignItems="center" sx={inputStyle}>
								<Typography
									variant="body2"
									textAlign="left"
									sx={{
										fontSize: '13pt',
										lineHeight: '20pt',
									}}
								>
									{lead?.prospect_name || ''}
								</Typography>
							</Box>
						</Grid>
						<Grid item xs={6}>
							<Typography
								variant="body2"
								textAlign="left"
								sx={{
									fontSize: '13pt',
									marginBottom: '12px',
								}}
							>
								Status
							</Typography>
							<Box display="flex" allignItems="center" sx={inputStyle}>
								<Typography
									variant="body2"
									textAlign="left"
									sx={{
										fontSize: '13pt',
										lineHeight: '20pt',
									}}
								>
									{lead?.lead_status || 'New'}
								</Typography>
							</Box>
						</Grid>
					</Grid>
					<Grid container spacing={2}>
						<Grid item xs={6}>
							<Typography
								variant="body2"
								textAlign="left"
								sx={{
									fontSize: '13pt',
									marginBottom: '12px',
								}}
							>
								Phone Number
							</Typography>
							<Box display="flex" allignItems="center" sx={inputStyle}>
								<Typography
									variant="body2"
									textAlign="left"
									sx={{
										fontSize: '13pt',
										lineHeight: '20pt',
									}}
								>
									{formatPhoneNumber(lead?.phone_number || '')}
								</Typography>
							</Box>
						</Grid>
						<Grid item xs={6}>
							<Typography
								variant="body2"
								textAlign="left"
								sx={{ fontSize: '13pt', marginBottom: '12px' }}
							>
								Address
							</Typography>
							<Box display="flex" allignItems="center" sx={inputStyle}>
								<Typography variant="body1">{lead?.address || ''}</Typography>
							</Box>
						</Grid>
					</Grid>
					<Stack>
						<Typography variant="body2" textAlign="left" sx={{ fontSize: '13pt', marginBottom: '12px' }}>
							Summary
						</Typography>
						<Box
							sx={{
								maxHeight: 300, // Adjust the height based on your needs
								overflowY: 'scroll',
								border: '1px solid #ccc',
								padding: '8px',
								marginBottom: '24px',
							}}
						>
							<Typography variant="body2" textAlign="left" sx={{ fontSize: '13pt', lineHeight: '20pt' }}>
								{lead?.call_summary || 'No summary available'}
							</Typography>
						</Box>

						<Typography variant="body2" textAlign="left" sx={{ fontSize: '13pt', marginBottom: '12px' }}>
							Transcript
						</Typography>
						<Box
							sx={{
								maxHeight: 300, // Adjust the height based on your needs
								overflowY: 'scroll',
								border: '1px solid #ccc',
								padding: '8px',
								marginBottom: '24px',
							}}
						>
							<Typography variant="body2" textAlign="left" sx={{ fontSize: '13pt', lineHeight: '20pt' }}>
								{lead?.transcript
									? lead.transcript.split('\n').map((line, index) => (
											<React.Fragment key={index}>
												{line}
												<br />
											</React.Fragment>
										))
									: 'No transcript available'}
							</Typography>
						</Box>
					</Stack>
				</Stack>
			)}
		</Grid>
	)
}
